import { Component } from "omi";

/**
 * A base class for components that are used to render nodes in the editor.
 */
export class NWNodeView<P = object, Actions = object> extends Component<P> {
  /**
   * The instance id of the editor in which the node is rendered in.
   */
  editorInstanceId: string | undefined;

  /**
   * The actions that are available to the node.
   */
  viewActions: Actions = {} as Actions;
}
